import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { inject, onMounted } from 'vue';
import { OverviewCategory } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'OverviewCategory',
  props: {
    name: {},
    categoryId: {},
    categoryKey: {}
  },
  setup(__props: any) {

const props = __props;



const registerOverviewCategory = inject<(category: OverviewCategory) => undefined>('registerOverviewCategory');

onMounted(() => {
  registerOverviewCategory({ ...props });
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, _toDisplayString(_ctx.name), 1))
}
}

})